import copy from "../../../copy/en/documents-consolidated.json" with { type: "json" };
import { Link, useLocation } from "react-router";
import { Building2, FileCheck2, History, Users } from "lucide-react";
import { SubNav } from "../../components/ui/Tabs.js";
import { useMe } from "../../auth/MeProvider.js";
import type { Me } from "../../lib/me.js";
import { SUBMISSIONS_PATH, ONBOARDING_PATH, REP_AGREEMENTS_PATH } from "./paths.js";
import { safeWorkflowReturnTo, withWorkflowReturnTo, workflowReturnLabel } from "../practices/workflowNavigation.js";

/** Match the existing personal-document reader; Practice capabilities are separate. */
export function personalDocumentsAvailable(me: Me | null, mfaBlocked: boolean) {
  return Boolean(me?.userId && me.authUserId && me.party?.id && me.scope && !mfaBlocked);
}

export function documentsSection(pathname: string, search: string, admin: boolean) {
  const params = new URLSearchParams(search);
  if (pathname === "/document-updates") return "personal";
  if (pathname !== "/documents") return "history";
  if (params.get("section") === "history") return "history";
  if (params.get("section") === "representatives" && admin) return "representatives";
  // Every existing exact practice/enrollment/document link retains its workspace.
  if (["practiceId", "enrollmentId", "documentId", "practice", "enrollment", "document"].some(key => params.has(key))) return "practices";
  if (params.get("section") === "practices") return "practices";
  return "practices";
}

export function DocumentsNavigation() {
  const { me, hasCap, mfaBlocked } = useMe(), location = useLocation();
  const admin = me?.role === "admin" && !me.viewAs;
  const section = documentsSection(location.pathname, location.search, admin);
  const returnTo = safeWorkflowReturnTo(new URLSearchParams(location.search).get("returnTo"));
  const items = [
    ...(personalDocumentsAvailable(me, mfaBlocked) ? [{ id: "personal", icon: FileCheck2, label: copy.myDocuments, to: "/document-updates" }] : []),
    ...(admin ? [{ id: "representatives", icon: Users, label: copy.representativesTab, to: "/documents?section=representatives" }] : []),
    ...(hasCap("documents:read") ? [{ id: "practices", icon: Building2, label: copy.practices, to: "/documents?section=practices" }] : []),
    ...(hasCap("view:all") ? [{ id: "history", icon: History, label: copy.history, to: "/documents?section=history" }] : []),
  ];
  return <><SubNav ariaLabel={copy.profileDocuments} items={items.map(item => ({ ...item, active: section === item.id, to: withWorkflowReturnTo(item.to, returnTo) }))} />{section === "history" ? <SubNav secondary ariaLabel={copy.history} items={[{ to: SUBMISSIONS_PATH, label: copy.submissions }, { to: ONBOARDING_PATH, label: copy.bundles }, { to: REP_AGREEMENTS_PATH, label: copy.agreements }].map(item => ({ ...item, to: withWorkflowReturnTo(item.to, returnTo) }))} /> : null}{returnTo && (section === "representatives" || section === "history") ? <p><Link to={returnTo}>{workflowReturnLabel(returnTo)}</Link></p> : null}</>;
}
